module.exports = __webpack_public_path__ + "img/766.b979a3a4.jpg";